import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Silakan hubungi kami melalui informasi di samping atau sosial
                  media di bawah ini.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="section-title">
              <h3>Contact Info</h3>
            </div>
            <ul className="contact-list">
              <li>
                <i className="fa fa-map-marker"></i>
                <strong>Address:</strong>{" "}
                {props.data ? props.data.address : "loading"}
              </li>
              <li>
                <i className="fa fa-envelope-o"></i>
                <strong>Email:</strong>{" "}
                {props.data ? props.data.email : "loading"}
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
